import { List, Map, Record } from "immutable";
import { ProductOptionGroupRecord, productOptionGroupFromJSON } from "common/records/ProductOptionGroup";
import { RootState, RootActions } from "common/reducers";
import {
  RECEIVE_PRODUCT_OPTION_GROUPS,
  RECEIVE_PRODUCT_OPTION_GROUP,
  ProductOptionGroupActions,
} from "common/reducers/productOptionGroup.action";
import { receive } from "common/reducers/Utils";
import { IdType } from "common/types";

export const ProductOptionGroupStateRecord = Record({
  byId: Map<IdType, ProductOptionGroupRecord>(),
});

export const initialState = ProductOptionGroupStateRecord();

export type ProductOptionGroupState = typeof initialState;

export type ProductOptionGroupReducerState = RootState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  const model = "productOptionGroups";
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }

  switch (action.type) {
    case RECEIVE_PRODUCT_OPTION_GROUPS:
      const productOptionGroups = List(action.payload.productOptionGroups);
      productOptionGroups.forEach((productOptionGroup) => {
        state = reducer(state, ProductOptionGroupActions.receiveProductOptionGroup(productOptionGroup));
      });
      return state;

    case RECEIVE_PRODUCT_OPTION_GROUP:
      const productOptionGroup: ProductOptionGroupRecord = productOptionGroupFromJSON(
        action.payload.productOptionGroup,
      );
      state = receive(state, model, productOptionGroup) as RootState;
      return state;

    default:
      return state;
  }
};
